/**
 * Wiring de Sentry — opt-in por env var.
 * Si `VITE_SENTRY_DSN` no está, `initSentry()` es no-op.
 */
import * as Sentry from "@sentry/react";

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: `simumed-frontend@${import.meta.env.VITE_APP_VERSION ?? "dev"}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0.05"),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR ?? "0.5",
    ),
    // Nunca enviar form inputs — son credenciales + PII de alumnos (Ley 21.719)
    sendDefaultPii: false,
    beforeSend(event) {
      // Scrub: remover Authorization y cookies si aparecen en request
      if (event.request?.headers) {
        for (const k of Object.keys(event.request.headers)) {
          if (["authorization", "cookie", "x-api-key"].includes(k.toLowerCase())) {
            event.request.headers[k] = "[redacted]";
          }
        }
      }
      return event;
    },
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
